import constants from "../../commonUtils/constants";
import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  filters: { keyword: "" },
  RolesList: { data: [], pagination: { currentPage: 1, perPage: constants.tableUI.defaultPerpage, total: 0 }},
  roleData: {},
  allPermissions: [],
  errors: { title: "", role: "" },
  errorMessage: "",
};

const Users = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case actionTypes.SET_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };
    case actionTypes.SET_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    case actionTypes.GET_ROLES_SUCCESS:
      return {
          ...state,
          loading: false,
          RolesList: action.payload,
          // errors: { roleId: "", sourceType: "", files: "" },
          // errorMessage: "",
      };
    case actionTypes.GET_ROLES_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.CREATE_ROLE_SUCCESS:
      return {
          ...state,
          loading: false,
          // RolesList: action.payload,
          // errors: { roleId: "", sourceType: "", files: "" },
          // errorMessage: "",
      };
    case actionTypes.CREATE_ROLE_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.UPDATE_ROLE_SUCCESS:
      return {
          ...state,
          loading: false,
          // RolesList: action.payload,
          // errors: { roleId: "", sourceType: "", files: "" },
          // errorMessage: "",
      };
    case actionTypes.UPDATE_ROLE_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.DELETE_ROLE_SUCCESS:
      return {
          ...state,
          loading: false,
          errorMessage: "",
      };
    case actionTypes.DELETE_ROLE_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.UPDATE_ROLE_STATUS_SUCCESS:
      return {
          ...state,
          loading: false,
          errorMessage: "",
      };
    case actionTypes.UPDATE_ROLE_STATUS_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.GET_ROLE_DATA_SUCCESS:
      return {
          ...state,
          loading: false,
          roleData: action.payload,
          // errors: { roleId: "", sourceType: "", files: "" },
          // errorMessage: "",
      };
    case actionTypes.GET_ROLE_DATA_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.GET_ALL_PERMISSIONS_SUCCESS:
      return {
          ...state,
          loading: false,
          allPermissions: action.payload,
          // errors: { roleId: "", sourceType: "", files: "" },
          // errorMessage: "",
      };
    case actionTypes.GET_ALL_PERMISSIONS_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.UPDATE_ROLE_PERMISSIONS_SUCCESS:
      return {
          ...state,
          loading: false,
      };
    case actionTypes.UPDATE_ROLE_PERMISSIONS_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    default:
      return state;
  }
};

export default Users;
